import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const ContactDropdown = ({ options = [], onSelectChange, name, selectedValue }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (options.length > 0 && selectedValue !== undefined && selectedValue !== null) {
      const selected = options.find(option => String(option.value) === String(selectedValue));

      setSelectedOption(selected || null);
    }
  }, [selectedValue, options]);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    onSelectChange({ target: { name: name, value: selectedOption?.value || '' } });
  };

  return (
    <div>
      <Select
        name={name}
        value={selectedOption}
        defaultValue={selectedOption} 
        required
        onChange={handleChange}
        options={options}
      />
    </div>
  );
}

export default ContactDropdown;
